import { Pagination } from "antd";
import styled from "styled-components";

export const StyledPagination = styled(Pagination)`
  .ant-pagination-item {
    border-color: lightgrey; // Red border around each page number button
    color:#005461;
    border-radius: 0;
  }

  .ant-pagination-item a {
    color: #005461; // Red color for the numbers
  }

  .ant-pagination-item-active {
    border-color: #de283b; // Red border around each page number button
    color:#005461;
    background: transparent;
  }

  .ant-pagination-item-active a {
    color: #de283b; // Active number color (optional, feel free to adjust)
    border-color: #de283b;
    background: transparent;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    border-color: red; // Red border for prev/next buttons
  }

  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    color: #005461; // Red prev/next arrow color
    border-color: lightgrey;
    border-radius: 0;
  }
`;